import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core'
import { WindowRef } from '@spartacus/core'

@Directive({
  selector: '[mbAccordionRowChange]'
})
export class MbAccordionRowChangeDirective implements OnDestroy, OnInit {

  @Output() domChange = new EventEmitter()
  observer = this.winRef.isBrowser() && new MutationObserver((mutations: MutationRecord[]) => {
      mutations.forEach((mutation: MutationRecord) => {
        if (mutation?.attributeName === 'class') {
          if ((mutation?.target as any)?.classList.contains('show')) {
            this.domChange.emit(mutation)
          }
        }
      })
    }
  ) || undefined

  constructor (protected el: ElementRef,
              protected winRef: WindowRef) {
  }

  ngOnInit () {
    this.observer?.observe(this.el.nativeElement, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    })
  }

  ngOnDestroy () {
    this.observer?.disconnect()
  }
}
